// @flow

/* eslint-disable ta-code-conventions/has-matching-storydoc */

import * as React from 'react';
import { withRouteContext } from './RouterContext';
import { parseUrl } from './canonicalUrl';
import type { Route, NavigateFunc } from './types';

/**
 * These props are provided by the withRouteContext HOC.
 */
type Props = {|
  /** The current route */
  route: Route,

  /** A function for navigating to another page */
  navigate: NavigateFunc,
  props: any,
  popping: boolean,
  previousRoute: any,
|};

/**
 * Integrates the current router context with the HTML History API.
 */
class History extends React.Component<Props> {
  componentDidMount() {
    // eslint-disable-next-line no-restricted-globals
    window.addEventListener('popstate', this.popState);
  }

  componentWillUnmount() {
    // eslint-disable-next-line no-restricted-globals
    window.removeEventListener('popstate', this.popState);
  }

  // For this function code coverage was disabled since it's almost impossible to mock window methods
  popState = /* istanbul ignore next */ (evt: any) => {
    // Use the event state, unless it's null, in which case we may be popping to
    // the first page view and will need to fall back to parsing the URL.
    let { state } = evt;
    if (!state || !state.page) {
      // eslint-disable-next-line no-restricted-globals
      state = parseUrl(window.location.pathname + window.location.search);
    }
    if (!state || !this.props.navigate(state, { noHistory: true })) {
      // eslint-disable-next-line no-restricted-globals
      window.location.reload();
    }
  };

  render() {
    return null;
  }
}

/** Default export of <History/> component wrapped with route context */
export default withRouteContext(History);
